import { render, staticRenderFns } from "./EditMobile.vue?vue&type=template&id=2de28e7c&scoped=true"
import script from "./EditMobile.vue?vue&type=script&lang=js"
export * from "./EditMobile.vue?vue&type=script&lang=js"
import style0 from "./EditMobile.vue?vue&type=style&index=0&id=2de28e7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de28e7c",
  null
  
)

export default component.exports